import { ReactComponent as ArrowRight } from '../icons/arrow-right.svg'
import { ReactComponent as ArrowLeft } from '../icons/arrow-left.svg'
import { ReactComponent as ArrowDown } from '../icons/arrow-down.svg'
// import { ReactComponent as Product } from '../icons/product.svg'
// import { ReactComponent as Lifecycle } from '../icons/lifecycle.svg'
// import { ReactComponent as Energy } from '../icons/energy.svg'

import { ReactComponent as Kinectrics } from '../icons/hexcon-kinectrics.svg'
import { ReactComponent as Fire } from '../icons/hexcon-fire.svg'
import { ReactComponent as Energy } from '../icons/hexcon-energy.svg'
import { ReactComponent as Dots } from '../icons/hexcon-dots.svg'


export default function Icon(props){

    return (
        <>
            { props.type === "Arrow Right" ? <ArrowRight className="interactive-icon interactive-icon--arrow-right" aria-hidden="true" /> : null}
            { props.type === "Arrow Left" ? <ArrowLeft className="interactive-icon interactive-icon--arrow-left" aria-hidden="true" /> : null}
            { props.type === "Arrow Down" ? <ArrowDown className="interactive-icon interactive-icon--arrow-down" aria-hidden="true" /> : null }
            {/* { props.type === "Product" ? <Product className="interactive-icon interactive-icon--product"/> : null }
            { props.type === "Life Cycle" ? <Lifecycle className="interactive-icon interactive-icon--lifecycle"/> : null }
            { props.type === "Energy and Infrastructure" ? <Energy className="interactive-icon interactive-icon--energy"/> : null } */}
            { props.type === "Kinectrics" ? <Kinectrics className="interactive-icon interactive-icon--kinectrics" aria-hidden="true" /> : null }
            { props.type === "Fire" ? <Fire className="interactive-icon interactive-icon--fire" aria-hidden="true" /> : null }
            { props.type === "Energy" ? <Energy className="interactive-icon interactive-icon--energy" aria-hidden="true" /> : null }
            { props.type === "Dots" ? <Dots className="interactive-icon interactive-icon--dots" aria-hidden="true"/> : null }
        </>
    )
}